import styles from './style.postcss';
import React from 'react';
import is from 'is_js';
import { Grid } from 'omni-common-ui';
import { List } from 'immutable';
import CICCategoryCard from 'components/CICCategoryCard';
import PropTypes from 'prop-types';
import { mergeCategoriesByName, categoryDeepMerge } from 'data/CoveredInClass/accessors';

const CoveredInClassCategoryView = (props) => {
  const {
    categories,
    isEdit,
    template,
    onCategoriesChanged,
  } = props;
  let renderedCategories = categories;
  if (! isEdit && template) {
    renderedCategories = categoryDeepMerge(template, categories);
  }

  function renderCategories() {
    const mergedCategories = mergeCategoriesByName(renderedCategories);
    if (mergedCategories.size > 0) {
      return <Grid>
        <Grid.Group>
          {
            mergedCategories.map((categoryObject) => {
              const lastIsOdd = (mergedCategories.size % 2 !== 0);
              if (lastIsOdd &&
                  mergedCategories.indexOf(categoryObject) === mergedCategories.size - 1) {
                return <Grid.Item xs={12}
                    sm={12}
                    md={12}
                    key={categoryObject.cicCategoryName}>
                  <div className={styles.CoveredInClassCategoryView_categoryCardContainer_lastodd}>
                    <CICCategoryCard title={categoryObject.cicCategoryName}
                        isEdit={isEdit}
                        categoriesList={categoryObject.cicCategoryItems}
                        onFreeTextChange={(freeText) =>
                          handleFreeTextChange(freeText, categoryObject.cicCategoryId)}
                        onItemCheck={(categoryId, itemId, value) =>
                          handleItemChecked(categoryId, itemId, value)} />
                  </div>
                </Grid.Item>;
              }
              return <Grid.Item xs={12} sm={12} md={6}>
                <div className={styles.CoveredInClassCategoryView_categoryCardContainer}>
                  <CICCategoryCard title={categoryObject.cicCategoryName}
                      isEdit={isEdit}
                      categoriesList={categoryObject.cicCategoryItems}
                      onFreeTextChange={(freeText) =>
                          handleFreeTextChange(freeText, categoryObject.cicCategoryId)}
                      onItemCheck={(categoryId, itemId, value) =>
                        handleItemChecked(categoryId, itemId, value)} />
                </div>
              </Grid.Item>;
            })
          }
        </Grid.Group>
      </Grid>;
    }
  }

  function handleItemChecked(categoryId, categoryItemId, isChecked) {
    const newCategories = getNewCategories(categoryId, categoryItemId, isChecked);
    onCategoriesChanged(newCategories);
  }

  function handleFreeTextChange(freeText, categoryId) {
    const newCategories = getNewCategoriesForFreeText(freeText, categoryId);
    onCategoriesChanged(newCategories);
  }

  function getNewCategoriesForFreeText(freeText, categoryId) {
    let newCategoriesArray = new List();
    if (categories) {
      newCategoriesArray = categories.map((categoryObject) => {
        if (categoryObject.cicCategoryId === categoryId) {
          return categoryObject.update('cicCategoryItems', (cicCategoryItems) => {
            const freeTextIndex = cicCategoryItems.findIndex(
              (item) => item.cicCategoryItemId === 0);
            if (freeTextIndex >= 0) {
              if (is.string(freeText) && is.not.empty(freeText)) {
                return cicCategoryItems.update(freeTextIndex, (item) =>
                item.set('cicCategoryItemName', freeText));
              }
              return cicCategoryItems.delete(freeTextIndex);
            }
          });
        }
        return categoryObject;
      });
    }
    return newCategoriesArray;
  }

  function getNewCategories(categoryId, itemId, isChecked) {
    let newCategoriesArray = new List();
    if (categories) {
      categories.map((categoryObject) => {
        if (categoryObject.cicCategoryId === categoryId &&
            categoryObject.cicCategoryItems) {
          const newItems = getNewCagetoryItems(
            categoryObject.cicCategoryItems,
            itemId,
            isChecked
          );
          newCategoriesArray = newCategoriesArray.push(categoryObject.set('cicCategoryItems', newItems));
        } else {
          newCategoriesArray = newCategoriesArray.push(categoryObject);
        }
        return false;
      });
    }

    return newCategoriesArray;
  }

  function getNewCagetoryItems(oldItems, itemId, isChecked) {
    let newItems = new List();
    oldItems.map((oldItem) => {
      if (oldItem.cicCategoryItemId === itemId) {
        const newItem = oldItem;
        newItems = newItems.push(newItem.set('isChecked', isChecked));
      } else {
        newItems = newItems.push(oldItem);
      }

      return false;
    });

    return newItems;
  }
  return <div className={styles.CoveredInClassCategoryView}>
    {renderCategories()}
  </div>;
};

CoveredInClassCategoryView.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  lessons: PropTypes.array,
  categories: PropTypes.shape({
    map: PropTypes.func,
  }).isRequired,
  template: PropTypes.shape({
    map: PropTypes.func,
  }).isRequired,
  onCategoriesChanged: PropTypes.func.isRequired,
};

export default CoveredInClassCategoryView;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClass/CoveredInClassCategoryView/index.jsx